import React from "react";
import { ScrollAnimation } from "../ScrollAnimation";

const galleryImages = [
  {
    src: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-04-14%20at%2023.19.48%20%281%29-8BoLulqOGzzS8xdObHhvxomvIWCGmw.jpeg",
    alt: "Recepção da clínica Mesquita",
  },
  {
    src: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-04-14%20at%2023.19.49%20%282%29-rNSLP8emL94zR45NRIOUa3S7OpnH30.jpeg",
    alt: "Sala de terapia com poltrona de couro marrom",
  },
  {
    src: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-04-14%20at%2023.26.26-VALX4ZVERUkXjXAOpmupXtRdqHNSKw.jpeg",
    alt: "Sala de atendimento com sofá curvo verde-sálvia",
  },
  {
    src: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-04-14%20at%2023.19.49%20%283%29-V8JcZAFQqZXZUn5zNCAtp6kYd9iN5L.jpeg",
    alt: "Sala de tratamento KAP",
  },
];

export default function Gallery() {
  return (
    <section id="espaco" className="py-20 sm:py-24 px-4 sm:px-6 lg:px-8 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <ScrollAnimation animation="fade-up">
          <span className="font-sans text-sm font-semibold text-[#C2A44A] tracking-wider uppercase mb-3 block text-center">Nosso Espaço</span>
        </ScrollAnimation>
        <ScrollAnimation animation="fade-up" delay={100}>
          <h2 className="font-sans text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#204613] mb-8 text-center text-balance max-w-4xl mx-auto leading-tight">
            Um ambiente pensado para o seu bem-estar
          </h2>
        </ScrollAnimation>
        <ScrollAnimation animation="fade-up" delay={150}>
          <p className="font-serif text-base sm:text-lg text-[#3d3d3d] mb-12 text-center max-w-2xl mx-auto">
            Cada detalhe foi cuidadosamente planejado para proporcionar conforto, privacidade e acolhimento durante sua jornada de cuidado.
          </p>
        </ScrollAnimation>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {galleryImages.map((image, idx) => (
            <ScrollAnimation key={idx} animation="fade-up" delay={200 + idx * 100}>
              <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-lg group">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#204613]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
}
